import { Component, EventEmitter, Input, Output, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AddressBookService } from "src/app/_core/_services/address-book/address-book.service";
import { TranslateService } from '@ngx-translate/core';
import { forkJoin } from "rxjs";
import { map } from "rxjs/operators";

interface Campaign {
 campaign_id: number;
 name?: string;
 name_workspace?: string;
 owner: number;
 status: number;
 is_activated?: boolean;
 public: string;
 answers: string;
 created: string;
 duration?: string;
 parent?: any;
 phone: string;
 isFavourite: boolean;
}

@Component({
 selector: "app-edit-status-contact-modal",
 templateUrl: "./edit-status-contact-modal.component.html",
 styleUrls: ["./edit-status-contact-modal.component.scss"],
})
export class EditStatusContactModalComponent implements OnInit {
 @Input() campaign: Campaign;
 @Input() allowedStatuses: number[] = []; 

 @Output() statusUpdated = new EventEmitter<number>();
 @Output() saveStatus = new EventEmitter<number>();
 @Output() closeModal = new EventEmitter<void>();

 statusForm: FormGroup;
 isLoading = false;

 availableStatuses: { value: number; label: string }[] = [];

 constructor(
  public activeModal: NgbActiveModal,
  private fb: FormBuilder,
  private addressBookService: AddressBookService,
  private translate: TranslateService
 ) {
  this.statusForm = this.fb.group({
   status: ["", Validators.required],
  });
 }

 ngOnInit(): void {
  this.loadAndFilterStatuses(); 

  if (this.campaign) {
   this.statusForm.patchValue({
    status: this.campaign.status,
   });
  }
 }

  loadAndFilterStatuses(): void {
    const allStatusDefs = [
      { value: 0, key: 'STATUS.QUEUE' },
      { value: 1, key: 'STATUS.PICKED_FOR_DIALING' },
      { value: 2, key: 'STATUS.CALL_ANSWERED' },
      { value: 3, key: 'STATUS.CALL_MISSED' },
      { value: 4, key: 'STATUS.CALL_REJECTED' },
      { value: 5, key: 'STATUS.CALL_ERROR' },
      { value: 6, key: 'STATUS.CALL_CANCELED' },
    ];

    const translationKeys = allStatusDefs.map(s => s.key);
    
    this.translate.get(translationKeys).subscribe(translations => {
      const allTranslatedStatuses = allStatusDefs.map(s => ({
        value: s.value,
        label: translations[s.key]
      }));

      if (this.allowedStatuses && this.allowedStatuses.length > 0) {
        this.availableStatuses = allTranslatedStatuses.filter(status => 
          this.allowedStatuses.includes(status.value)
        );
      } else {
        this.availableStatuses = allTranslatedStatuses;
      }
    });
  }

 saveChanges(): void {
  if (this.statusForm.valid) {
   this.isLoading = true;
   const newStatus = this.statusForm.value.status;
   this.addressBookService
    .updatePhoneNumberStatus(this.campaign.public, { status: newStatus })
    .subscribe(
     (response) => {
      this.statusUpdated.emit(newStatus);
      this.activeModal.close(newStatus);
      this.isLoading = false;
     },
     (error) => {
      console.error("Error updating campaign status:", error);
      this.isLoading = false;
     }
    );
  }
 }

 close(): void {
  this.activeModal.dismiss('cancel');
 }
}